<template>
  <section
    v-if="documentData.showLargeAmountResponsibles"
    class="dte-standard-footer"
  >
    <table class="dte-standard-table dte-standard-table--plain dte-standard-table--responsibles">
      <tbody>
        <tr>
          <td class="dte-standard-table__label dte-standard-table__label--inline">
            Responsable por parte del Emisor:
          </td>
          <td>{{ documentData.footerContacts.issuerName || "--" }}</td>
          <td class="dte-standard-table__label dte-standard-table__label--inline">
            No. documento:
          </td>
          <td>{{ documentData.footerContacts.issuerDocument || "--" }}</td>
          <td class="dte-standard-table__label dte-standard-table__label--inline">
            Telefono:
          </td>
          <td>{{ documentData.footerContacts.issuerPhone || "--" }}</td>
        </tr>
        <tr>
          <td class="dte-standard-table__label dte-standard-table__label--inline">
            Responsable por parte del Receptor:
          </td>
          <td>{{ documentData.footerContacts.receiverName || "--" }}</td>
          <td class="dte-standard-table__label dte-standard-table__label--inline">
            No. documento:
          </td>
          <td>{{ documentData.footerContacts.receiverDocument || "--" }}</td>
          <td class="dte-standard-table__label dte-standard-table__label--inline">
            Telefono:
          </td>
          <td>{{ documentData.footerContacts.receiverPhone || "--" }}</td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
export default {
  name: "DteStandardFooterSection",
  props: {
    documentData: {
      type: Object,
      required: true,
    },
  },
};
</script>
